import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { usePageTitle } from '../hooks/usePageTitle';
import '../styles/contact.css';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const { settings } = useSettings();
  usePageTitle('Liên hệ');
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: ''
  });
  const [formStatus, setFormStatus] = useState(null); // null | 'sending' | 'sent' | 'error'

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setFormStatus('sending');

  try {
    await emailjs.send(
      'service_68t7k3d',
      'template_0ztm4bh',
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      },
      'Sa8N8wTFrOe38CShP'
    );

    setFormStatus('sent');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });

    setTimeout(() => setFormStatus(null), 4000);
  } catch (error) {
    console.error(error);
    setFormStatus('error');
  }
};

  const shopName = settings.shop_name || '';
  const phone = settings.phone || '';
  const email = settings.email || '';
  const address = settings.address || '';

  return (
    <>
      {/* Hero Section */}
      <section className="contact-hero-v2">
        <div className="contact-hero-bg">
          <div className="hero-gradient-overlay"></div>
          <div className="hero-pattern"></div>
        </div>
        <div className="container">
          <div className="contact-hero-inner">
            <nav className="breadcrumb-nav">
              <Link to="/">Trang chủ</Link>
              <span className="breadcrumb-sep">›</span>
              <span className="breadcrumb-current">Liên hệ</span>
            </nav>
            <h1 className="contact-hero-title">
              Kết nối với <span className="text-gradient">{shopName}</span>
            </h1>
            <p className="contact-hero-desc">
              Chúng tôi luôn sẵn sàng lắng nghe và mang đến giải pháp hoa tươi hoàn hảo cho bạn
            </p>
          </div>
        </div>
      </section>

      {/* Contact Cards Strip */}
      <section className="contact-cards-strip">
        <div className="container">
          <div className="cards-row">
            <a 
              href={`tel:${phone.replace(/\s/g, '')}`} 
              className="mini-card"
              onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(`tel:${phone.replace(/\s/g, '')}`)}
            >
              <div className="mini-card-icon phone-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <div className="mini-card-info">
                <h4>Hotline</h4>
                <p>{phone}</p>
              </div>
              <i className="fas fa-arrow-right mini-card-arrow"></i>
            </a>

            <a href={`mailto:${email}`} className="mini-card">
              <div className="mini-card-icon email-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="mini-card-info">
                <h4>Email</h4>
                <p>{email}</p>
              </div>
              <i className="fas fa-arrow-right mini-card-arrow"></i>
            </a>

            <a 
              href={settings.zalo_url || '#'} 
              className="mini-card" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(settings.zalo_url || '#')}
            >
              <div className="mini-card-icon zalo-icon">
                <img src="/images/zalo.svg" alt="Zalo" style={{ width: '32px', height: '32px' }} />
              </div>
              <div className="mini-card-info">
                <h4>Zalo Chat</h4>
                <p>Phản hồi tức thì</p>
              </div>
              <i className="fas fa-arrow-right mini-card-arrow"></i>
            </a>

            <div className="mini-card">
              <div className="mini-card-icon location-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="mini-card-info">
                <h4>Showroom</h4>
                <p>{address}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content: Form + Contact Info */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-main-grid">
            {/* LEFT: Contact Form */}
            <div className="contact-form-wrapper">
              <div className="form-header">
                <span className="form-label">Gửi tin nhắn</span>
                <h2>Chúng tôi sẽ phản hồi trong <strong>2 giờ</strong></h2>
                <p>Điền thông tin bên dưới và đội ngũ tư vấn sẽ liên hệ bạn sớm nhất.</p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Họ và tên <span className="required">*</span></label>
                    <input
                      type="text" id="name" name="name"
                      placeholder="Nguyễn Văn A"
                      value={formData.name} onChange={handleChange} required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email <span className="required">*</span></label>
                    <input
                      type="email" id="email" name="email"
                      placeholder="email@example.com"
                      value={formData.email} onChange={handleChange} required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Số điện thoại</label>
                    <input
                      type="tel" id="phone" name="phone"
                      placeholder="0912 345 678"
                      value={formData.phone} onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Chủ đề</label>
                    <select id="subject" name="subject" value={formData.subject} onChange={handleChange}>
                      <option value="">Chọn chủ đề</option>
                      <option value="order">Đặt hoa</option>
                      <option value="custom">Thiết kế theo yêu cầu</option>
                      <option value="event">Trang trí sự kiện</option>
                      <option value="delivery">Giao hàng</option>
                      <option value="other">Khác</option>
                    </select>
                  </div>
                </div>
                <div className="form-group full-width">
                  <label htmlFor="message">Nội dung tin nhắn <span className="required">*</span></label>
                  <textarea
                    id="message" name="message" rows="5"
                    placeholder="Mô tả yêu cầu của bạn..."
                    value={formData.message} onChange={handleChange} required
                  />
                </div>
                <button
                  type="submit"
                  className={`submit-btn ${formStatus === 'sending' ? 'loading' : ''} ${formStatus === 'sent' ? 'success' : ''}`}
                  disabled={formStatus === 'sending'}
                >
                  {formStatus === 'sending' && (
                    <><i className="fas fa-spinner fa-spin"></i> Đang gửi...</>
                  )}
                  {formStatus === 'sent' && (
                    <><i className="fas fa-check"></i> Đã gửi thành công!</>
                  )}
                  {(!formStatus || formStatus === 'error') && (
                    <><i className="fas fa-paper-plane"></i> Gửi tin nhắn</>
                  )}
                </button>
              </form>
            </div>

            {/* RIGHT: Info Sidebar */}
            <div className="contact-sidebar">
              <div className="sidebar-card hours-card">
                <div className="sidebar-card-header">
                  <i className="fas fa-clock"></i>
                  <h3>Giờ làm việc</h3>
                </div>
                <ul className="hours-list">
                  <li>
                    <span>Thứ 2 — Chủ nhật</span>
                    <span className="hours-time">6:00 — 22:00</span>
                  </li>
                  <li>
                    <span>Ngày lễ</span>
                    <span className="hours-time">6:00 — 22:00</span>
                  </li>
                </ul>
                <div className="open-status">
                  <span className="status-dot"></span>
                  Đang mở cửa
                </div>
              </div>

              <div className="sidebar-card social-card">
                <div className="sidebar-card-header">
                  <i className="fas fa-share-alt"></i>
                  <h3>Theo dõi chúng tôi</h3>
                </div>
                <div className="social-grid">
                  <a href={settings.facebook_url || '#'} className="social-item facebook" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                    <span>Facebook</span>
                  </a>
                  <a href={settings.instagram_url || '#'} className="social-item instagram" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                    <span>Instagram</span>
                  </a>
                  <a 
                    href={settings.zalo_url || '#'} 
                    className="social-item zalo" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(settings.zalo_url || '#')}
                  >
                    <img src="/images/zalo.svg" alt="Zalo" style={{ width: '24px', height: '24px', marginRight: '6px' }} />
                    <span>Zalo</span>
                  </a>
                  <a 
                    href={`tel:${phone.replace(/\s/g, '')}`} 
                    className="social-item phone"
                    onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(`tel:${phone.replace(/\s/g, '')}`)}
                  >
                    <i className="fas fa-phone-alt"></i>
                    <span>Gọi ngay</span>
                  </a>
                </div>
              </div>

              <div className="sidebar-card trust-card">
                <div className="trust-items">
                  <div className="trust-item">
                    <div className="trust-icon"><i className="fas fa-shipping-fast"></i></div>
                    <span>Giao hàng miễn phí nội thành</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon"><i className="fas fa-shield-alt"></i></div>
                    <span>Cam kết hoa tươi 100%</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon"><i className="fas fa-camera"></i></div>
                    <span>Gửi ảnh trước khi giao</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon"><i className="fas fa-stopwatch"></i></div>
                    <span>Giao hoa nhanh 60 phút</span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon"><i className="fas fa-hand-holding-usd"></i></div>
                    <span>Tư vấn mẫu theo ngân sách</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Banner Section */}
      <section className="contact-banner-section" style={{ textAlign: 'center', padding: '40px 0' }}>
        <div className="container">
          <h2 style={{ fontSize: '2rem', marginBottom: '15px', color: 'var(--text-dark)' }}>
            Liên hệ đặt hoa nhanh – {shopName}
          </h2>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-light)' }}>
            Hỗ trợ 24/7 – Giao hoa tận nơi
          </p>
        </div>
      </section>
    </>
  );
};

export default Contact;